<template>
<!-- ==========促销补差策略组件 ==============-->
<div>
  <div class="salesPromotion">
    <el-form :model="FZCX" class="toolbar" ref="FZCX" label-width="100px">
      <el-row>
        <el-col>复杂促销（线上&线下）</el-col>
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>折扣
          <el-tooltip content="包括但不限于品类、品牌、单品折扣、积分折扣、会员折扣等" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-radio-group v-model="zkGroup" style="width:100%;" :disabled="isLook" @change="zkChange">
              <el-col :span="4"><el-radio :label="1">售价损失补差</el-radio></el-col>
              <el-col :span="7">
                <el-row>
                  <el-col>
                    <el-form-item label="≤5折" prop="XY5Z" style="font-size:14px;">
                      <el-input-number v-model="FZCX.XY5Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                      <span class="suffixRight">%</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="5折＜X≤6折" prop="D5X6Z" style="font-size:14px;">
                      <el-input-number v-model="FZCX.D5X6Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                      <span class="suffixRight">%</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="6折＜X≤7折" prop="D6X7Z" style="font-size:14px;">
                      <el-input-number v-model="FZCX.D6X7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                      <span class="suffixRight">%</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="＞7折" prop="DY7Z" style="font-size:14px;">
                      <el-input-number v-model="FZCX.DY7Z" :disabled="isLook || zkGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                      <span class="suffixRight">%</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="4" :offset="1" style="margin-right:10px;"><el-radio :label="2">目标毛利率补差</el-radio></el-col>
              <el-col :span="7">
                <el-form-item label-width="0" prop="ZKMBMLLBC" style="font-size:14px;">
                  <el-input-number v-model="FZCX.ZKMBMLLBC" :disabled="isLook || zkGroup != '2'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </el-col>
            </el-radio-group>
          </el-row>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>买赠
          <el-tooltip content="包括免单" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="4"><el-radio v-model="radioMz" label="1" :disabled="isLook" >售价损失补差</el-radio></el-col>
            <el-col :span="7">
              <el-form-item label-width="0" prop="MZSJSSBC" style="font-size:14px;">
                <el-input-number v-model="FZCX.MZSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                <span class="suffixRight">%</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>梯次
          <el-tooltip content="梯次促销" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="4"><el-radio v-model="radioMz" label="1" :disabled="isLook" >售价损失补差</el-radio></el-col>
            <el-col :span="7">
              <el-form-item label-width="0" prop="TCSJSSBC" style="font-size:14px;">
                <el-input-number v-model="FZCX.TCSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                <span class="suffixRight">%</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>送券
          <el-tooltip content="售价损失等于券面金额" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="4"><el-radio v-model="radioSj" label="1" :disabled="isLook">售价损失补差</el-radio></el-col>
            <el-col :span="7">
              <el-form-item label-width="0" prop="SQSJSSBC" style="font-size:14px;">
                <el-input-number v-model="FZCX.SQSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                <span class="suffixRight">%</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>出清
          <el-tooltip content="只针对不可退商品，可退商品原则上不出清，否则100%承担补差" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="4"><el-radio v-model="radioCq" label="1" :disabled="isLook">售价损失补差</el-radio></el-col>
            <el-col :span="7">
              <el-form-item label-width="0" prop="CQSJSSBC" style="font-size:14px;">
                <el-input-number v-model="FZCX.CQSJSSBC" :disabled="isLook" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                <span class="suffixRight">%</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="2"><span class="red classify">*</span>其它
          <el-tooltip content="包括但不限于满立减、组合促销等" placement="top" class="tooltipBtn">
            <el-button icon="el-icon-question" circle size="mini"></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-radio-group v-model="otherGroup" style="width:100%;" :disabled="isLook" @change="qtChange">
              <el-col :span="4"><el-radio :label="1">售价损失补差</el-radio></el-col>
              <el-col :span="7">
                <el-form-item label-width="0" prop="QTSJSSBC" style="font-size:14px;">
                  <el-input-number v-model="FZCX.QTSJSSBC" :disabled="isLook || otherGroup != '1'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="1" style="margin-right:10px;"><el-radio :label="2">目标毛利率补差</el-radio></el-col>
              <el-col :span="7">
                <el-form-item label-width="0" prop="QTMBMLLBC" style="font-size:14px;">
                  <el-input-number v-model="FZCX.QTMBMLLBC" :disabled="isLook || otherGroup != '2'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
                  <span class="suffixRight">%</span>
                </el-form-item>
              </el-col>
            </el-radio-group>
          </el-row>
        </el-col>        
      </el-row>
    </el-form>
  </div>
</div>
</template>
<script>
export default {
  props:{
    contractLocalid:{
      type:Number,
      required:true
    },
    GETFZCX:{
      type:Object,
      required:true
    }
  },
  data(){
    return {
      FZCX:{
        "D6X7Z": undefined,
        "MZSJSSBC": undefined,
        "SQSJSSBC": undefined,
        "CQSJSSBC": undefined,
        "DY7Z": undefined,
        "D5X6Z": undefined,
        "QTMBMLLBC": undefined,
        "QTSJSSBC": undefined,
        "XY5Z": undefined,
        "ZKMBMLLBC": undefined,
        'TCSJSSBC':undefined,
      },
      zkGroup: 1,   //折扣单选组
      otherGroup: 1,  //其它单选组
      radioMz: '1',   //买赠
      radioSj: '1',   //送券
      radioCq: '1',   //出清
      source:'',
      FZCXrules:{
        XY5Z: [{ required: true, message: '请填写', trigger: 'blur' },],
        D5X6Z: [{ required: true, message: '请填写', trigger: 'blur' },],
        D6X7Z: [{ required: true, message: '请填写', trigger: 'blur' },],
        DY7Z: [{ required: true, message: '请填写', trigger: 'blur' },],
        ZKMBMLLBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        MZSJSSBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        SQSJSSBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        CQSJSSBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        QTSJSSBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        QTMBMLLBC: [{ required: true, message: '请填写', trigger: 'blur' },],
        TCSJSSBC: [{ required: true, message: '请填写', trigger: 'blur' },],
      }
    }
  },
  methods: {    
      //折扣单选按钮切换
      zkChange(val){
          if(val == 2){
              this.FZCX.XY5Z = undefined;
              this.FZCX.D5X6Z = undefined;
              this.FZCX.D6X7Z = undefined;
              this.FZCX.DY7Z = undefined;
          }else{
              this.FZCX.ZKMBMLLBC = undefined;
          }
      },
      //其他单选按钮切换
      qtChange(val){
          if(val == 2){
              this.FZCX.QTSJSSBC = undefined;
          }else{
              this.FZCX.QTMBMLLBC = undefined;
          }
      },
    validateOther(flag){
      if((this.zkGroup == 1 && ((isNaN(Number(this.FZCX.XY5Z)) || this.FZCX.XY5Z < 0) || (isNaN(Number(this.FZCX.D5X6Z)) || this.FZCX.D5X6Z < 0) || (isNaN(Number(this.FZCX.D6X7Z)) || this.FZCX.D6X7Z < 0) || (isNaN(Number(this.FZCX.DY7Z)) || this.FZCX.DY7Z < 0))) || (this.zkGroup == 2 && (isNaN(Number(this.FZCX.ZKMBMLLBC)) || this.FZCX.ZKMBMLLBC < 0))){
        this.msgCallback('请补全折扣数据');
      }else if(isNaN(Number(this.FZCX.MZSJSSBC)) || this.FZCX.MZSJSSBC < 0){
        this.msgCallback('请补全买赠数据');
      }else if(isNaN(Number(this.FZCX.TCSJSSBC)) || this.FZCX.TCSJSSBC < 0){
        this.msgCallback('请补梯次数据');
      }else if(isNaN(Number(this.FZCX.SQSJSSBC)) || this.FZCX.SQSJSSBC < 0){
        this.msgCallback('请补全送券数据');
      }else if(isNaN(Number(this.FZCX.CQSJSSBC)) || this.FZCX.CQSJSSBC < 0){
        this.msgCallback('请补全出清数据');
      }else if((this.otherGroup == 1 && (isNaN(Number(this.FZCX.QTSJSSBC)) || this.FZCX.QTSJSSBC < 0)) || (this.otherGroup == 2 && (isNaN(Number(this.FZCX.QTMBMLLBC)) || this.FZCX.QTMBMLLBC < 0))){
        this.msgCallback('请补全其他数据');
      }else{
        //如果校验通过传true给父组件用来判断
        this.$emit("getUpdateFlag",true);
        // this.updateFlag = true
      }
    },
    //结果返回成功失败类型的接口回调
    msgCallback(info){
      this.$message.error(info);
      return false
    },
  },
    created(){
      if(this.GETFZCX){
        this.FZCX = this.GETFZCX
      }
      if(this.FZCX.ZKMBMLLBC){
        this.zkGroup = 2;
      }
      if(this.FZCX.QTMBMLLBC){
        this.otherGroup = 2;
      }
      let param = JSON.parse(sessionStorage.getItem('param'));
      this.source = param.source || "detail";
    },
    watch: {  
      FZCX:{
          handler:function(nowVal,oldVal){
              this.$emit('getFZCX',nowVal)
          },
          deep:true
      }
    },
    computed:{
      isLook(){
        return this.source=="detail";
      },
      isEdit(){
        return this.source=="edit";
      },
      isAdd(){
        return this.source=="add";
      },
    }
}
</script>
<style lang="scss" scoped>
.salesPromotion{
  .el-button.is-circle{
    border: none;
    &:hover{
      background: none;
    }
  }
  .red{
    color: #f00;
  }
  
}
</style>
<style lang="scss">
.salesPromotion{
  padding-top: 10px;
  .classify{
    line-height: 30px;
  }
  .el-radio__label{
    line-height: 30px;
  }
  .el-button--mini.is-circle{
    padding: 2px;
  }
  .el-form-item__label{
    font-size: 14px;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/contractmanagement/purchasecontract/add/module/ContractSalesPromotion.vue